import { defineComponent as ne, useSlots as le, ref as l, computed as h, useAttrs as ae, watchEffect as re, watch as A, onMounted as oe, onBeforeUnmount as ie, createElementBlock as N, createCommentVNode as S, openBlock as R, mergeProps as ue, toHandlers as se, createElementVNode as c, createVNode as v, createTextVNode as ce, toDisplayString as H, normalizeClass as B, unref as I } from "vue";
import { useResizeObserver as ve } from "@vueuse/core";
import { RevButtonIcon as j } from "@ds/components/ButtonIcon";
import fe from "../../icons/generated/IconChevronLeft.vue2.js";
import me from "../../icons/generated/IconChevronRight.vue2.js";
import { track as de } from "@ds/tracking/tracking";
import { isBrowser as pe } from "../../utils/client.js";
import { isEmpty as he } from "../../utils/isEmpty.js";
import { tw as O } from "../../utils/tailwind.js";
import { skipFragment as be, isVNodeEmpty as xe } from "../../utils/vnode.js";
import ye from "../CardCarousel/components/CardCarouselController.vue2.js";
import { IntervalInMillisecond as ge } from "./Carousel.constant.js";
import X from "./components/CarouselController.vue2.js";
import ke from "./components/CarouselItems.vue2.js";
const Ie = { class: "relative flex w-full grow justify-center" }, Ce = {
  class: "sr-only",
  role: "status"
}, we = ["aria-labelledby"], _e = {
  key: 0,
  class: "mx-auto mt-16 flex w-full max-w-[1072px] items-center px-12"
}, Ve = /* @__PURE__ */ ne({
  name: "RevCarousel",
  inheritAttrs: !1,
  __name: "Carousel",
  props: {
    alternativeButtonLabel: {},
    alternativeNext: {},
    alternativePrevious: {},
    tracking: { default: null },
    thumbnails: { default: void 0 },
    autoplay: { type: Boolean, default: !1 },
    interval: { default: ge },
    currentIndexId: {}
  },
  emits: ["slide-impression", "next-button-click", "prev-button-click", "navigation-click", "swipe"],
  setup(Y, { emit: F }) {
    const u = Y, C = le(), f = F, w = l(null), b = l(void 0), m = l(null), d = l(null), n = l(0), x = l(0), y = l(0), g = l(!1), k = l(u.autoplay), E = l(0), L = h(
      () => be(C == null ? void 0 : C.default({})).filter(
        (e) => !xe(e)
      )
    ), r = h(() => L.value.length), W = h(() => !he(u.thumbnails)), q = ae();
    function P() {
      f("slide-impression", { index: n.value }), de({
        action: "carousel-impression",
        context: {
          ...q,
          ...u.tracking,
          currentSlide: n.value
        }
      });
    }
    const p = l(!1), _ = l(0);
    function M() {
      const e = m.value instanceof HTMLElement ? m.value.offsetWidth : 0, t = b.value instanceof HTMLElement ? b.value.offsetWidth : 48, a = l(0);
      _.value === 0 ? (a.value = w.value instanceof HTMLElement ? w.value.offsetWidth : 0, _.value = a.value) : a.value = _.value;
      const i = e - t * 2;
      return a.value > i;
    }
    function G() {
      n.value >= r.value - 1 ? n.value = 0 : n.value += 1;
    }
    function J() {
      n.value === 0 ? n.value = r.value - 1 : n.value -= 1;
    }
    function K(e) {
      e !== n.value && (n.value = e);
    }
    function s(e) {
      g.value && (k.value = !1), typeof e == "number" && K(e), e === "previous" && J(), e === "next" && G(), P();
    }
    function z(e) {
      const t = e.touches[0];
      x.value = t.clientX, y.value = t.clientY;
    }
    function $(e) {
      if (!x.value || !y.value)
        return;
      const t = e.touches[0].clientX, a = e.touches[0].clientY, i = x.value - t, T = y.value - a;
      Math.abs(i) > Math.abs(T) && (f("swipe"), i > 0 ? s("next") : s("previous")), x.value = 0, y.value = 0;
    }
    const Q = h(() => [
      p.value && O`absolute left-0 z-10 mt-4`
    ]), Z = h(() => [
      p.value && O`absolute right-0 z-10 mt-4`
    ]), ee = re((e) => {
      if (k.value && pe()) {
        let t = 0;
        const a = setInterval(() => {
          g.value || (s("next"), t = 0);
        }, u.interval), i = 50, T = setInterval(() => {
          t += i, g.value || (E.value = t / u.interval);
        }, i);
        e(() => {
          clearInterval(a), clearInterval(T);
        });
      }
    });
    function o(e) {
      g.value = e;
    }
    function D() {
      o(!0), f("next-button-click"), s("next");
    }
    function U() {
      o(!0), f("prev-button-click"), s("previous");
    }
    function V(e) {
      o(!0), f("navigation-click"), s(e);
    }
    function te(e) {
      if (e === "forward") {
        D();
        return;
      }
      U();
    }
    return A(
      () => u.autoplay,
      async (e) => {
        k.value = e;
      },
      { immediate: !0 }
    ), A(
      () => m.value,
      () => {
        p.value = M(), ve(m, () => {
          p.value = M();
        });
      }
    ), oe(() => {
      var e, t;
      (e = d.value) == null || e.addEventListener("touchmove", $, !1), (t = d.value) == null || t.addEventListener("touchstart", z, !1), P();
    }), ie(() => {
      var e, t;
      (e = d.value) == null || e.removeEventListener("touchstart", z, !1), (t = d.value) == null || t.removeEventListener("touchmove", $, !1), ee();
    }), (e, t) => {
      var a;
      return r.value ? (R(), N("div", ue({
        key: 0,
        ref_key: "carousel",
        ref: d,
        class: ["relative -mb-4 flex min-h-72 flex-col flex-wrap overflow-hidden", [e.$attrs.class, ((a = e.thumbnails) == null ? void 0 : a.length) ?? "pb-4"]]
      }, se({
        focusin: () => o(!0),
        focusout: () => o(!1),
        mouseout: () => o(!1),
        mouseover: () => o(!0)
      }, !0)), [
        c("div", Ie, [
          v(ke, {
            "current-index": n.value,
            "current-index-id": e.currentIndexId,
            items: L.value
          }, null, 8, ["current-index", "current-index-id", "items"]),
          c("div", Ce, [
            ce(H(n.value + 1) + " / " + H(r.value) + ". ", 1),
            c("span", { "aria-labelledby": e.currentIndexId }, null, 8, we)
          ])
        ]),
        !W.value && r.value > 1 ? (R(), N("div", _e, [
          v(X, {
            "autoplay-running": k.value,
            "button-aria-label": e.alternativeButtonLabel,
            class: "mx-auto md:mx-0",
            "current-index": n.value,
            "image-count": r.value,
            "interval-progression": E.value,
            onSelect: V
          }, null, 8, ["autoplay-running", "button-aria-label", "current-index", "image-count", "interval-progression"]),
          v(ye, {
            "can-scroll-next": !0,
            "can-scroll-prev": !0,
            class: "ml-auto hidden md:block",
            "next-alternative-text": e.alternativeNext,
            "prev-alternative-text": e.alternativePrevious,
            onScroll: te
          }, null, 8, ["next-alternative-text", "prev-alternative-text"])
        ])) : S("", !0),
        W.value && r.value > 1 ? (R(), N("div", {
          key: 1,
          ref_key: "controllerContainerRef",
          ref: m,
          class: B(["relative isolate mx-auto flex w-full justify-center pt-12", { "h-60": e.thumbnails }])
        }, [
          c("div", {
            ref_key: "prevButtonRef",
            ref: b,
            class: B(["flex items-center px-8 py-4", Q.value])
          }, [
            v(I(j), {
              "alternative-text": e.alternativePrevious,
              icon: I(fe),
              size: "small",
              type: "button",
              variant: "primary",
              onClick: U
            }, null, 8, ["alternative-text", "icon"])
          ], 2),
          c("div", {
            ref_key: "controllerWrapperRef",
            ref: w
          }, [
            v(X, {
              "button-aria-label": e.alternativeButtonLabel,
              "current-index": n.value,
              "image-count": r.value,
              "prev-button-ref": b.value,
              "should-thumbnails-scroll": p.value,
              thumbnails: e.thumbnails,
              onSelect: V
            }, null, 8, ["button-aria-label", "current-index", "image-count", "prev-button-ref", "should-thumbnails-scroll", "thumbnails"])
          ], 512),
          c("div", {
            class: B(["flex items-center px-8 py-4", Z.value])
          }, [
            v(I(j), {
              "alternative-text": e.alternativeNext,
              icon: I(me),
              size: "small",
              type: "button",
              variant: "primary",
              onClick: D
            }, null, 8, ["alternative-text", "icon"])
          ], 2)
        ], 2)) : S("", !0)
      ], 16)) : S("", !0);
    };
  }
});
export {
  Ve as default
};
